function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "Layer_1_21_"
}, React.createElement("path", {
  d: "M518.288,545.7l-85.425-155.55c24.225-3.825,42.074-25.5,42.074-49.726v-229.5C474.937,49.725,425.212,0,364.012,0 h-145.35c-61.2,0-112.2,49.725-112.2,112.2v228.225c0,25.5,17.85,45.9,42.075,49.726L64.387,545.7 c-6.375,12.75-2.55,28.05,10.2,34.425c3.825,2.55,7.65,2.55,11.475,2.55c8.925,0,17.85-5.1,21.675-12.75l7.65-12.75h351.9 l7.649,12.75c5.101,8.925,12.75,12.75,21.676,12.75c3.824,0,7.649-1.274,11.475-2.55C520.837,573.75,524.663,558.45,518.288,545.7 z M398.437,430.95h-214.2l21.675-39.525h170.85L398.437,430.95z M394.613,345.525c-20.4,0-36.976-16.575-36.976-36.976 c0-20.4,16.575-36.975,36.976-36.975c20.399,0,36.975,16.575,36.975,36.975C431.587,327.675,415.012,345.525,394.613,345.525z  M151.087,126.225c0-39.525,31.875-71.4,70.125-71.4h138.975c38.25,0,71.4,31.875,71.4,71.4v61.2 c0,14.025-11.475,24.225-25.5,24.225h-229.5c-14.025,0-24.225-11.475-24.225-24.225L151.087,126.225L151.087,126.225z  M188.062,270.3c20.4,0,36.975,16.575,36.975,36.976c0,20.399-16.575,36.975-36.975,36.975s-36.975-16.575-36.975-36.975 C151.087,286.875,167.663,270.3,188.062,270.3z M135.788,518.925l28.05-49.725h255l28.05,49.725H135.788z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgTrain = function SvgTrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "582.675px",
    height: "582.675px",
    viewBox: "0 0 582.675 582.675",
    style: {
      enableBackground: "new 0 0 582.675 582.675"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/train.f1bdd893.svg";
export { ForwardRef as ReactComponent };